<div *ngIf="isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div *ngIf="columnChart; else accessDenied">
  <!-- Recent Transactions -->
  <div class="panel">
    <div class="mb-5 text-lg font-bold">
      {{ "statistics.yearly_revenue" | translate }}
    </div>
    <div class="w-40">
      <p>{{ "statistics.year" | translate }}:</p>
      <ng-select
        [items]="yearOptions"
        [(ngModel)]="selectedYear"
        (change)="onFilterChange()"
        placeholder="{{ 'contract.filter_placeholder' | translate }}"
        class="custom-multiselect"
        bindLabel="label"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
        appendTo="body"
      ></ng-select>
    </div>
    <apx-chart
      [series]="columnChart.series"
      [chart]="columnChart.chart"
      [colors]="columnChart.colors"
      [dataLabels]="columnChart.dataLabels"
      [stroke]="columnChart.stroke"
      [plotOptions]="columnChart.plotOptions"
      [grid]="columnChart.grid"
      [xaxis]="columnChart.xaxis"
      [yaxis]="columnChart.yaxis"
      [tooltip]="columnChart.tooltip"
      class="rounded-lg bg-white dark:bg-black"
    ></apx-chart>
  </div>
</div>

<div class="panel mt-4" *ngIf="columnContractChart">
  <div class="mb-5 text-lg font-bold">
    {{ "statistics.customer_activities" | translate }}
  </div>
  <div class="w-40">
    <p>{{ "contract.instance_status" | translate }}:</p>
    <ng-select
      [items]="filterOptions"
      [(ngModel)]="selectedFilter"
      (change)="onFilterChange()"
      placeholder="{{ 'contract.filter_placeholder' | translate }}"
      class="custom-multiselect"
      bindLabel="label"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      appendTo="body"
    ></ng-select>
  </div>
  <apx-chart
    [series]="columnContractChart.series"
    [chart]="columnContractChart.chart"
    [colors]="columnContractChart.colors"
    [dataLabels]="columnContractChart.dataLabels"
    [stroke]="columnContractChart.stroke"
    [plotOptions]="columnContractChart.plotOptions"
    [grid]="columnContractChart.grid"
    [xaxis]="columnContractChart.xaxis"
    [yaxis]="columnContractChart.yaxis"
    [tooltip]="columnContractChart.tooltip"
    class="rounded-lg bg-white dark:bg-black"
  ></apx-chart>
</div>

<ng-template #accessDenied>
  <div class="text-center text-red-500">
    {{ "statistics.access_denied" | translate }}
  </div>
</ng-template>
